module.exports = __webpack_public_path__ + "img/reviewInProgress.afcdc3bd.svg";